import React from "react";
import Footer from "../../components/general components/Footer";
import Header from "../../components/general components/Header";
import * as C from "./styles";
import Post from "../../components/Post";
import { motion, AnimatePresence } from "framer-motion";
import { BsGearFill } from "react-icons/bs";

const Blog = () => {
  return (
    <C.Container>
      <Header />
      <h1>Blog</h1>
      <BsGearFill/>
      <AnimatePresence>
        <motion.div
          initial={{ x: 300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -300, opacity: 0 }}
          transition={{ duration: 1.5 }}
        >
          <C.Posts>
          </C.Posts>
        </motion.div>
      </AnimatePresence>
      <Footer />
    </C.Container>
  );
};

export default Blog;
